export enum EMPLOYEE_PERMISSION_POS {
  ALL = 'all',
  MOVE = 'move',
  DISCOUNT = 'discount',
  SET_PRICE = 'set_price',
  PAYMENT = 'payment',
  VOID_ITEMS = 'void_items',
  VOID_BILL = 'void_bill',

}

export enum EMPLOYEE_PERMISSION_PAGES {
  ALL = 'all',
  POS = 'pos',
  REPORTS = 'reports',
  SETTINGS = 'settings',
  MENU = 'menu',
  USERS = 'users',
  INVENTORY = 'inventory',
  EXPENSES = 'expenses',
  DASHBOARD = 'dashboard',
  DISABLE_DASHBOARD_SALES = 'disable_sales_dashboard',
  HISTORY = 'logs',
  CHECK_PRINTER = 'check-printer',
}


export const EMPLOYEE_PERMISSIONS_LINK_TO_PATH = {
  [EMPLOYEE_PERMISSION_POS.ALL]: '/',
  [EMPLOYEE_PERMISSION_PAGES.POS]: '/pos',
  [EMPLOYEE_PERMISSION_PAGES.REPORTS]: '/reports',
  [EMPLOYEE_PERMISSION_PAGES.SETTINGS]: '/settings',
  [EMPLOYEE_PERMISSION_PAGES.MENU]: '/menu/items',
  [EMPLOYEE_PERMISSION_PAGES.USERS]: '/users',
  [EMPLOYEE_PERMISSION_PAGES.INVENTORY]: '/inventory',
  [EMPLOYEE_PERMISSION_PAGES.EXPENSES]: '/expenses',
  [EMPLOYEE_PERMISSION_PAGES.DASHBOARD]: '/dashboard',
  [EMPLOYEE_PERMISSION_PAGES.HISTORY]: '/logs',
  [EMPLOYEE_PERMISSION_PAGES.CHECK_PRINTER]: '/check-printer',
}

// สิทธิ์ของหน้า ผูกกับ "ต้นทาง path" ไม่ใช่ path เต็ม
// ของเดิมเป็นตารางเทียบ path เต็มทีละหน้า พอเพิ่มหน้าใหม่แล้วลืมมาเติม
// หน้านั้นจะกลายเป็นไม่มีสิทธิ์ไหนคุม แล้วถูกปฏิเสธทันทีถ้าไม่ได้ติ๊ก "ทั้งหมด"
// เทียบแบบ prefix จึงครอบหน้าลูกที่เพิ่มทีหลังให้อัตโนมัติ
export const EMPLOYEE_PATH_PREFIX_TO_PERMISSIONS: [string, string][] = [
  ['/pos', EMPLOYEE_PERMISSION_PAGES.POS],
  ['/logs', EMPLOYEE_PERMISSION_PAGES.HISTORY],
  ['/check-printer', EMPLOYEE_PERMISSION_PAGES.HISTORY],
  ['/reports', EMPLOYEE_PERMISSION_PAGES.REPORTS],
  ['/menu', EMPLOYEE_PERMISSION_PAGES.MENU],
  ['/inventory', EMPLOYEE_PERMISSION_PAGES.INVENTORY],
  ['/expenses', EMPLOYEE_PERMISSION_PAGES.EXPENSES],
  ['/dashboard', EMPLOYEE_PERMISSION_PAGES.DASHBOARD],
  ['/settings', EMPLOYEE_PERMISSION_PAGES.SETTINGS],
  ['/users', EMPLOYEE_PERMISSION_PAGES.USERS],
]

// คืนสิทธิ์ที่คุมหน้านี้ ไม่มีตัวไหนคุม = null (ผู้เรียกเป็นคนตัดสินว่าจะปล่อยผ่านหรือไม่)
// เทียบทีละ segment ไม่ใช่ substring : "/settings/users" ต้องเป็นสิทธิ์ตั้งค่า ไม่ใช่สิทธิ์ผู้ใช้งาน
export const resolvePagePermission = (path?: string | null): string | null => {
  if (!path) return null

  const cleaned = path.split('?')[0].split('#')[0].replace(/\/+$/, '') || '/'

  let matched: { prefix: string; permission: string } | null = null
  for (const [prefix, permission] of EMPLOYEE_PATH_PREFIX_TO_PERMISSIONS) {
    if (cleaned !== prefix && !cleaned.startsWith(`${prefix}/`)) continue
    // prefix ที่ยาวกว่าชนะ เผื่อวันหน้ามีหน้าลูกที่ต้องใช้สิทธิ์ต่างจากพ่อ
    if (!matched || prefix.length > matched.prefix.length) {
      matched = { prefix, permission }
    }
  }

  return matched?.permission ?? null
}

export interface Employee {
  storeId: string
  employeeId: string
  name: string
  pin: string
  repin: string
  pages_permissions: EMPLOYEE_PERMISSION_PAGES
  pos_actions: EMPLOYEE_PERMISSION_POS
  createdAt: string
}